import { render, staticRenderFns } from "./TheSiteSidebar.vue?vue&type=template&id=44294cb8&"
import script from "./TheSiteSidebar.vue?vue&type=script&lang=js&"
export * from "./TheSiteSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44294cb8')) {
      api.createRecord('44294cb8', component.options)
    } else {
      api.reload('44294cb8', component.options)
    }
    module.hot.accept("./TheSiteSidebar.vue?vue&type=template&id=44294cb8&", function () {
      api.rerender('44294cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/partials/TheSiteSidebar.vue"
export default component.exports